// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 971) return "static/chunks/971.0a9500b35036beb6.js";
	if (chunkId === 658) return "static/chunks/658.6bd54e0e67136faf.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"505":"892ea49d18210479","784":"2f6f83165728f5dd","892":"5b1774ee5a83d0f4"}[chunkId] + ".js";
};